export default __webpack_public_path__ + "46f9a87b417619ad9d5f1d9fd6eda4fb.svg";